import React from "react";

import "./ExcalidrawWatermark.scss";

export const ExcalidrawWatermark: React.FC = () => {
  return (
    <div className="excalidraw-watermark">
      <div className="excalidraw-watermark__icon-box">
        <span className="excalidraw-watermark__semicolon">;</span>
      </div>
      <div className="excalidraw-watermark__divider" />
      <div className="excalidraw-watermark__text">
        <span className="excalidraw-watermark__text-top">MADE WITH</span>
        <span className="excalidraw-watermark__text-bottom">EXCALIDRAW</span>
      </div>
    </div>
  );
};
